module.exports = __webpack_public_path__ + "img/inner-ring.6e9372ef.png";